export function toggleResizeEvent() {
  if (window) {
    // После выхода/входа в полноэкранный режим нужно рефрешнуть канвас и галерею
    setTimeout(function () {
      if (Event instanceof Function) {
        window.dispatchEvent(new Event('resize'));
      } else {
        // IE11
        var event = document.createEvent('Event');
        event.initEvent('resize', true, true);
        document.dispatchEvent(event);
      }
    });
  }
}